import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AuthService } from '@src/app/core/services/auth.service';
import { WorkflowDefinitionService } from '@src/app/core/services/workflow/workflow-definition.service';

/**
 * Guard para rotas de preenchimento de workflow (fill).
 * Permite acesso se o usuário está autenticado OU se o workflow é público (isPublic).
 * Caso contrário redireciona para o login.
 */
export const workflowFillGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const definitionService = inject(WorkflowDefinitionService);

  if (auth.isUserAuthenticated()) {
    return true;
  }

  const slug = route.paramMap.get('workflowSlug');
  if (!slug) {
    router.navigate(['/login']);
    return false;
  }

  return definitionService.getPublicConfig(slug).pipe(
    map((config) => {
      if (config?.isPublic) {
        return true;
      }
      router.navigate(['/login']);
      return false;
    }),
    catchError(() => {
      router.navigate(['/login']);
      return of(false);
    })
  );
};
